//http://share2.xdevel.com/api/?platform=earone_8&key=2a09e52f6df41dc6d9e41c20abb950b2&get=playlist
/*
{
    success: true,
    time: "2020-04-20 15:07:03",
    result: [
        {
            songHash: "45832f7cda66e508839f215c367447ba",
            programId: "5108",
            programName: "Rudy e Laura",
            programMode: "1",
            datePlay: "2020-04-20 15:00:33",
            curPos: null,
            peakPos: null,
            artist: "SIMPLE MINDS",
            title: "Don't You (Forget About Me)",
            label: "",
            coverUrl: "https://admuzzum.xdevel.com/covers_sorted/2018/1170/1b880a857b79ca17c0b415b46a9932b6.jpg",
            radioDate: null,
            newsText: ""
        }
    ]
}
 */

export default function (data, limit = 5) {
    let result = [];
    let count = 0;

    if (data.success) {
        let item;
        for (let i = 0; i < data.result.length; i++) {
            item = data.result[i];
            if (count >= limit) break;
            if (!item.coverUrl || (item.coverUrl + '').includes('null.jpg')) continue;

            let datePlayParts = item.datePlay.split(' ');
            let datePlay = datePlayParts[1] || '';

            result.push({
                artist: item.artist,
                title: item.title,
                artwork: item.coverUrl400,
                datePlay
            });
            count++;
        }
    }

    return result;
}